// @flow
import React from 'react';

import { createEnchereUpdateOeuvre, updateEnchere } from 'Api';
import EnchereForm from 'pages/Avila/Enchere/Form'

import FormModal from './FormModal'
import { useTranslation } from 'react-i18next'

type Props = {
    oeuvreid: string,
    onClose: any => any,
    actions: Array<any>,
    data: any,
    onSave: any => any,
    isMultiple: boolean
}
export default ({
    onClose,
    actions = [],
    data,
    oeuvreid,
    oeuvre,
    onSave = () => {},
    isMultiple = false
}: Props) => {

    const { t } = useTranslation();

    return (

        <FormModal
            title={t("auction")}
            data={data}
            onClose={onClose}
            FormComponent={({ data, onChange }) => (
                <EnchereForm
                    isMultiple={isMultiple}
                    data={data}
                    onChange={onChange}
                />
            )}

            onSave={onSave}
            updateMethod={({ data }) => updateEnchere({oeuvreid, data })}
            createMethod={({ data }) => createEnchereUpdateOeuvre({ oeuvre, data })}
        />
    )
}